export { default } from './ConfirmDialog.container';
